// Existing invoice services own persistence and accounting; this adapter checks their receipts.
const invoiceListActionsApi = {
  create: (deps: any) => async (operation: string, row: any, options: any) => {
    const b = deps.backend()
    if (operation === 'send' || operation === 'reminder') {
      const email = options.recipientEmail || deps.customerEmail(row)
      const customerId = row?._backend?.customerId || row?._backend?.customer?.id || row?.customerId
      if (operation === 'send' && options.saveContact && customerId && typeof b.addCustomerContactPerson === 'function') {
        await b.addCustomerContactPerson({ customerId, name: options.contactName || '', role: options.contactRole || '', email })
      }
      const result = await b.sendInvoiceDocument(deps.sendPayload(row, email), {
        deliveryMode: options.deliveryMode || 'attachment',
        emailSubject: operation === 'send' ? (options.subject || deps.sendSubject(row)) : `${options.variant === 'purring' ? 'Purring' : 'Betalingspåminnelse'}: ${row.num}`,
        ...(operation === 'reminder' ? { variant: options.variant, emailMessage: options.comment || '',
          followUpPaymentSummary: { paidAmount: Number(row.paidAmount) || 0, remainingAmount: Number(row.remainingAmount) + (Number(options.fee) || 0),
            originalRemainingAmount: row.remainingAmount, reminderFee: Number(options.fee) || 0, dueDate: options.dueDate } } : {}),
      })
      return { confirmed: result?.emailSent === true, result: 'sent' }
    }
    if (operation === 'register_payment' || operation === 'refund') {
      const payment = await b.addInvoicePayment(row, { id: crypto.randomUUID(), amount: options.amount, date: options.date,
        settlementAccountCode: options.settlementAccountCode, settlementKind: 'payment', feeAmount: Number(options.feeAmount) || 0,
        feeAccountCode: options.feeAccountCode || undefined, note: options.note || '' })
      return { confirmed: Boolean(payment?.id), result: operation === 'refund' ? 'refunded' : 'paid', paymentId: payment?.id }
    }
    if (operation === 'edit_payment') {
      const payment = await b.replaceInvoicePayment(options.paymentId, { amount: options.amount, date: options.date,
        settlementAccountCode: options.settlementAccountCode, settlementKind: 'payment', feeAmount: Number(options.feeAmount) || 0,
        feeAccountCode: options.feeAccountCode || undefined, note: options.note || '' })
      return { confirmed: Boolean(payment?.id), result: 'payment_updated', paymentId: payment?.id }
    }
    if (operation === 'reverse_payment') {
      await b.reverseInvoicePayment(options.paymentId)
      return { confirmed: true, result: 'payment_reversed', paymentId: options.paymentId }
    }
    if (operation === 'settle_without_payment') {
      const payment = await b.addInvoicePayment(row, { id: crypto.randomUUID(), amount: row.remainingAmount, date: options.date,
        settlementAccountCode: options.settlementAccountCode, settlementKind: 'no_payment', note: options.note || 'Oppgjort uten betaling' })
      return { confirmed: Boolean(payment?.id), result: 'settled_without_payment', paymentId: payment?.id }
    }
    if (operation === 'delete_draft') return { confirmed: await b.deleteInvoice(row) === true, result: 'deleted' }
    if (operation === 'archive' || operation === 'restore') {
      const result = await b.archiveInvoice(row, operation === 'archive')
      return { confirmed: Boolean(result?.id) && Boolean(result.archivedAt) === (operation === 'archive'), result: operation === 'archive' ? 'archived' : 'restored' }
    }
    const result = operation === 'credit' ? await b.creditInvoice(row, { creditReason: options.creditReason || '', issue: options.issue === true, selections: options.selections })
      : await b.issueInvoiceDraft(row, { creditReason: options.creditReason || '' })
    const expectedStatus = operation === 'credit' && options.issue !== true ? 'draft' : 'completed'
    return { confirmed: Boolean(result?.id) && result.status === expectedStatus, result: expectedStatus === 'draft' ? 'creditDraft' : 'issued', documentId: result?.id }
  },
}
Object.assign(globalThis, { PlummeInvoiceListActions: invoiceListActionsApi })
